<template>
  <app-button
    v-if="hasApplied"
    block
    color="dark"
    data-cy-applied
    disabled
    :size="size"
    tag="span"
    variant="tonal"
  >
    Vous avez postulé 💜
  </app-button>

  <app-button
    v-else-if="isSoldOut"
    block
    :color="color"
    data-cy-sold-out-cta
    disabled
    icon="ph:circle-wavy-warning"
    :size="size"
    :variant="variant"
  >
    Complet
  </app-button>

  <growth-contact-button
    v-else
    block
    :class="{ 'bg-deco2 hover:!bg-deco2/90 !text-black': !color && !variant }"
    :color="color"
    data-cy-apply
    :origin="origin"
    :origin_page_action="origin_page_action"
    :origin_page_id="origin_page_id"
    :redirect="redirect"
    :size="size"
    :variant="variant"
  >
    Demander votre place
  </growth-contact-button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";

import type { ContactFlowMetadata } from "~~/model/analytics.model";

defineProps<
  ButtonProps &
    ContactFlowMetadata & {
      redirect: string;
      hasApplied: boolean;
      isSoldOut: boolean;
    }
>();
</script>
